import React from 'react';
import Header from '../../Components/Header/Header';
import Banner from '../../Components/Banner/Banner';

const HeaderBanner = ({ onSignUpClick, onSignInClick }) => (
  <>
    <Header onSignUpClick={onSignUpClick} onSignInClick={onSignInClick} />
    <Banner onSignUpClick={onSignUpClick} onSignInClick={onSignInClick} />
  </>
);

export default HeaderBanner;
